// ACTIVITE
import aquabike1 from "../../assets/images/activites/aquabike/IMG_8954.jpg";
import aquabike2 from "../../assets/images/activites/aquabike/IMG_9018.jpg";
import aquabike5 from "../../assets/images/activites/aquabike/Vital'Eau-588.jpg";
import aquabike6, { default as aquabike } from "../../assets/images/activites/aquabike/vitaleau-activite-aquabikingbongosoft-1.jpg";
import aquabike3 from "../../assets/images/activites/aquabike/vitaleau-activite-aquabikingbongosoft-3.jpg";
import aquadynamic3 from "../../assets/images/activites/aquabikeDynamic/IMG_8954.jpg";
import aquadynamic1 from "../../assets/images/activites/aquabikeDynamic/IMG_9018.jpg";
import aquadynamic2 from "../../assets/images/activites/aquabikeDynamic/P1050459.jpg";
import { default as aquabikedynamic } from "../../assets/images/activites/aquabikeDynamic/Vital-Eau-762.jpg";
import adulteCouv from "../../assets/images/activites/aquabikeDynamic/VitalEau-762-couv.jpg";
import aquafitness2 from "../../assets/images/activites/aquafitness/vitaleau-activite-aquagym-1.jpg";
import aquafitness1 from "../../assets/images/activites/aquafitness/vitaleau-activite-aquagym-2.jpg";
import aquafitness3 from "../../assets/images/activites/aquafitness/vitaleau-activite-aquagym-5.jpg";
import { default as aquafitness, default as aquafitness4 } from "../../assets/images/activites/aquafitness/VitalEau-activites-087.jpg";
import { default as aquagym1, default as seniorCouv } from "../../assets/images/activites/aquagym/vitaleau-activite-aquagymdouce-1.jpg";
import aquagym2 from "../../assets/images/activites/aquagym/vitaleau-activite-aquagymdouce-2.jpg";
import aquagym3 from "../../assets/images/activites/aquagym/vitaleau-activite-aquagymdouce-3.jpg";
import aquagym4 from "../../assets/images/activites/aquagym/vitaleau-activite-aquagymdouce-4.jpg";
import { default as aquagym5, default as aquagymdouceCouv } from "../../assets/images/activites/aquagym/vitaleau-adapte-1.jpg";
import aquatonic1 from "../../assets/images/activites/aquagymTonique/vitaleau-activite-aquagymtonic-2.jpg";
import aquatonic2 from "../../assets/images/activites/aquagymTonique/vitaleau-activite-aquagymtonic-3.jpg";
import {
    default as aquagymtonicCouv,
    default as aquatonic3,
} from "../../assets/images/activites/aquagymTonique/vitaleau-activite-aquagymtonic-4.jpg";
import aquatonic4 from "../../assets/images/activites/aquagymTonique/VitalEau-activites-087.jpg";
import aquatraining1 from "../../assets/images/activites/aquatraining/_MG_3143.jpg";
import { default as aquatraining2, default as aquatrainingCouv } from "../../assets/images/activites/aquatraining/P1050375.jpg";
import aquatraining3 from "../../assets/images/activites/aquatraining/P1050392.jpg";
import aquatraining5 from "../../assets/images/activites/aquatraining/P1050429.jpg";
import aquatraining4 from "../../assets/images/activites/aquatraining/P1050459.jpg";
import aquatraining6 from "../../assets/images/activites/aquatraining/P1050491.jpg";
import bebe1 from "../../assets/images/activites/bebe/Vital'Eau suite-304.webp";
import { default as bebe2, default as bebenageurCouv } from "../../assets/images/activites/bebe/vitaleau-bebes-nageurs-1.webp";
import bebe3 from "../../assets/images/activites/bebe/vitaleau-bebes-nageurs-2.webp";
import bebe4 from "../../assets/images/activites/bebe/vitaleau-bebes-nageurs-3.webp";
import bebe5 from "../../assets/images/activites/bebe/vitaleau-bebes-nageurs-4.webp";
import { default as body1, default as bodyBike } from "../../assets/images/activites/bodyBike/aquabodybikebongointense-1.jpg";
import body3 from "../../assets/images/activites/bodyBike/aquabodybikebongointense-2.jpg";
import body4 from "../../assets/images/activites/bodyBike/IMG_8954.jpg";
import body5 from "../../assets/images/activites/bodyBike/IMG_9018.jpg";
import {
    default as decouverte1,
    default as enfantsCouv,
    default as sectiondecouverteCouv,
} from "../../assets/images/activites/decouverte/vitaleau-ecole-de-natation-decouverte-1.jpg";
import decouverte2 from "../../assets/images/activites/decouverte/vitaleau-ecole-de-natation-decouverte-2.jpg";
import decouverte3 from "../../assets/images/activites/decouverte/vitaleau-ecole-de-natation-decouverte-3.jpg";
import decouverte4 from "../../assets/images/activites/decouverte/vitaleau-section-apprentisage-3.jpg";
import enfant8 from "../../assets/images/activites/Enfant-App-Perf-Nat/Vital'Eau suite-491.webp";
import {
    default as enfant1,
    default as sectionapprentissageCouv,
} from "../../assets/images/activites/Enfant-App-Perf-Nat/vitaleau-ecole-de-natation-decouverte-2.jpg";
import enfant2 from "../../assets/images/activites/Enfant-App-Perf-Nat/vitaleau-perfectionnement-1.jpg";
import enfant3 from "../../assets/images/activites/Enfant-App-Perf-Nat/vitaleau-perfectionnement-2.jpg";
import {
    default as enfant4,
    default as sectionperfectionnementCouv,
} from "../../assets/images/activites/Enfant-App-Perf-Nat/vitaleau-perfectionnement-3.jpg";
import enfant5 from "../../assets/images/activites/Enfant-App-Perf-Nat/vitaleau-section-apprentisage-2.jpg";
import enfant6 from "../../assets/images/activites/Enfant-App-Perf-Nat/vitaleau-stage-vacances-scolaire-1.jpg";
import {
    default as enfant7,
    default as stageNatationCouv,
} from "../../assets/images/activites/Enfant-App-Perf-Nat/vitaleau-stage-vacances-scolaire-2.jpg";
import initiation6 from "../../assets/images/activites/initiation/vitaleau-activite-ecoledenatation-initiation-1.jpg";
import initiation5 from "../../assets/images/activites/initiation/vitaleau-activite-ecoledenatation-initiation-2.jpg";
import {
    default as initiation2,
    default as sectioninitiationCouv,
} from "../../assets/images/activites/initiation/vitaleau-activite-ecoledenatation-initiation-3.jpg";
import initiation3 from "../../assets/images/activites/initiation/vitaleau-activite-ecoledenatation-initiation-4.jpg";
import initiation4 from "../../assets/images/activites/initiation/vitaleau-activite-ecoledenatation-initiation-5.jpg";
import initiation1 from "../../assets/images/activites/initiation/vitaleau-activite-ecoledenatation-initiation-6.jpg";
import bannerAdultes from "../../assets/images/activites/Vitaleau-Montage-Adultes_Activites_Categorie.webp";
import bannerBebes from "../../assets/images/activites/Vitaleau-Montage-Bebes_Activites_Categorie.webp";
import bannerEnfants from "../../assets/images/activites/Vitaleau-Montage-Enfants_Activites_Categorie.webp";
import bannerSeniors from "../../assets/images/activites/Vitaleau-Montage-Senior_Activites_Categorie.webp";
import AquabikeIcon from "../atoms/AquabikeIcon";
import AquagymIcon from "../atoms/AquagymIcon";
import BebeIcon from "../atoms/BebeIcon";
import SwimIcon from "../atoms/SwimIcon";

const activites = [
    // 🍼 Catégorie Bébés (redirige vers l’activité)
    {
        src: bannerBebes,
        miniature: bebenageurCouv,
        titre: "Activités bébés",
        introtext: "Des moments de découverte et de complicité dans l’eau dès les premiers mois.",
        resume: "Chez Vital’Eau, les tout-petits découvrent le milieu aquatique en douceur et en sécurité.",
        text: "<p>Nos séances de bébés nageurs offrent aux parents et aux enfants un moment unique...</p>",
        icon: <BebeIcon />,
        iconGradient: <BebeIcon gradient />,
        slug: "bebes",
        profil: "bébé",
        isCategory: true,
        redirectToActivity: true, // 👈 nouvelle clé
    },
    // 🧒 Catégorie enfants
    {
        src: bannerEnfants,
        miniature: enfantsCouv,
        titre: "Activités enfants",
        introtext: "Des activités aquatiques adaptées aux plus jeunes, pour apprendre en s’amusant et développer leur aisance dans l’eau.",
        resume: "Les cours enfants permettent de découvrir les bases de la natation dans un environnement ludique et sécurisé.",
        text: "<p>Nos coachs accompagnent les enfants dans leur progression à travers des activités variées...</p>",
        icon: <SwimIcon />,
        iconGradient: <SwimIcon gradient />,
        slug: "enfants",
        profil: "enfant",
        isCategory: true,
    },
    // 💪 Catégorie adultes
    {
        src: bannerAdultes,
        miniature: adulteCouv,
        titre: "Activités adultes",
        introtext: "Renforcez votre tonus, entretenez votre forme ou dépassez vos limites avec nos activités aquatiques pour adultes.",
        resume: "Cours d’aquafitness, d’aquabike et bien d’autres pour un entraînement complet et dynamique.",
        text: "<p>Nos activités pour adultes sont conçues pour tous les niveaux...</p>",
        icon: <AquabikeIcon />,
        iconGradient: <AquabikeIcon gradient />,
        slug: "adultes",
        profil: "adulte",
        isCategory: true,
    },
    // 🧓 Catégorie seniors
    {
        src: bannerSeniors,
        miniature: seniorCouv,
        titre: "Activités seniors",
        introtext: "Bougez en douceur et conservez votre mobilité grâce à nos cours spécialement conçus pour les seniors.",
        resume: "Des activités douces et encadrées favorisant la santé, la souplesse et la convivialité.",
        text: "<p>Nos activités aquatiques seniors sont axées sur le bien-être et la mobilité articulaire...</p>",
        icon: <AquagymIcon />,
        iconGradient: <AquagymIcon gradient />,
        slug: "seniors",
        profil: "sénior",
        isCategory: true,
    },
    // Liste des activités
    {
        src: bannerBebes,
        titre: "Bébés nageurs",
        age: "(De 4/5 mois à 3 ans)",
        introtext: "Un formidable moment de complicité avec votre bébé.",
        text: "<p>Contrairement à la majorité des piscines où l'activité 'bébés nageurs' se limite à un simple aménagement de bassin – avec les parents laissés en totale autonomie et une surveillance distante par des maîtres-nageurs –, notre approche chez Vital'Eau est radicalement différente. Votre coach personnel vous accompagne activement pour faire progresser votre enfant, en développant à la fois sa motricité globale et sa relation sereine avec l'eau.<br/> <br/>Pour commencer, il vous guidera pas à pas : comment tenir votre bébé en toute sécurité, comment l'arroser doucement pour stimuler son réflexe de l’apnée et enfin comment l'immerger avec confiance et tendresse. Une fois cet apprentissage des bases maîtrisé, nous passerons à des exercices ludiques pour stimuler sa motricité : sauts joyeux, saltos arrière, saltos avant et même des petits trajets sous l'eau... Vous serez émerveillés par les prouesses que vos enfants accompliront, bien plus tôt que vous ne l'imaginiez ! <br/><br/> Rejoignez-nous pour transformer ces moments dans l’eau en souvenirs inoubliables. Inscrivez-vous dès aujourd'hui et découvrez la magie de l'eau en famille !</p>",
        icon: <BebeIcon />,
        iconGradient: <BebeIcon gradient />,
        link: "activites/bebes-nageurs",
        slug: "bebes-nageurs",
        profil: "bébé",
        swiper: [
            {
                images: bebe1,
            },
            {
                images: bebe2,
            },
            {
                images: bebe3,
            },
            {
                images: bebe4,
            },
            {
                images: bebe5,
            },
        ],
        duree: {
            label: "durée",
            value: "30'",
        },
        intensite: {
            label: "Intensité",
            value: "faible à modérée",
        },
        enpratique: {
            items: [
                {
                    number: "1",
                    text: "Venez avec du coton ou des cotons-tiges bébé, une collation, un maillot de bain Splash About, du sérum Phy.",
                },
                {
                    number: "2",
                    text: "Eau propre, non agressive et chauffée à 33°.",
                },
                {
                    number: "3",
                    text: "Présence des 2 parents possible. Et même souhaitable ;)",
                },
                {
                    number: "4",
                    text: "Tables à langer et sèches cheveux mises à votre disposition dans les vestiaires.",
                },
            ],
        },
    },
    {
        src: sectioninitiationCouv,
        titre: "Section initiation",
        age: "(À partir de 4 ans)",
        introtext: "Pour apprendre à nager sans stress ni sélection.",
        text: "Pour les enfants de 4 à 6 ans (en moyenne), notre section Initiation met l’accent sur des exercices très ludiques dans l’eau (jeux, sauts, déplacements avec flotteurs, etc.), des gestes adaptés à leur morphologie et une pédagogie adaptée à leur âge.",
        icon: <SwimIcon />,
        iconGradient: <SwimIcon gradient />,
        link: "/natation-enfants-i",
        slug: "natation-enfants-i",
        profil: "enfant",
        swiper: [
            {
                images: initiation1,
            },
            {
                images: initiation2,
            },
            {
                images: initiation3,
            },
            {
                images: initiation4,
            },
            {
                images: initiation5,
            },
            {
                images: initiation6,
            },
        ],
        duree: {
            label: "durée",
            value: "45'",
        },
        objectifs: {
            titre: "Les objectifs",
            baseline: "apprendre à nager bien-sûr ;)",
            text: "Au terme d’une année scolaire de pratique, la plupart des enfants maitrisent les capacités premières du nageur : l’immersion, le déplacement et la respiration aquatique. Ils sont capable de traverser sans flotteurs la longueur du bassin. Ils savent aussi prendre un objet immergé à 1m30 de profondeur sans appréhension. Ils ont assimilés les premiers gestes approximatifs en brasse, dos et crawl.",
        },
        bienfaits: {
            titre: "Les bienfaits",
            swiper: [
                {
                    text: "Une pratique intense qui reste ludique, sans stress ni sélection.",
                },
                {
                    text: "La sociabilisation de votre enfant grâce au travail en groupe.",
                },
                {
                    text: "Un développement musculaire - et cérébral - complet et harmonieux.",
                },
                {
                    text: "L’acquisition progressive d’une autonomie complète en milieu aquatique.",
                },
            ],
        },
        pourqui: {
            titre: "Pour qui ?",
            baseline: "tous les enfants sont les bienvenus",
            text: "Pour les enfants de 4 à 6 ans (en moyenne).",
        },
        seancebaseline: "chacun son rythme",
        seance: [
            {
                number: "1",
                text: "L’échauffement, pour « se mettre dans le bain » , avec une série de longueurs au choix. Votre enfant passe de la terre à l’eau.",
            },
            {
                number: "2",
                text: "Un temps de travail technique dit « éducatif », avec des exercices très ciblés, sur le ventre et sur le dos et des exercices de respiration.",
            },
            {
                number: "3",
                text: "Un temps de travail dédié à la nage complète, qui sollicite la bonne coordination entre la respiration et la technique.",
            },
            {
                number: "4",
                text: "Un moment de jeux et de récréation tous ensemble pour clore la séance.",
            },
        ],
        enpratique: {
            items: [
                {
                    number: "1",
                    text: "Intégrer et maitriser la respiration aquatique « inspirer par la bouche et souffler par le nez »",
                },
                {
                    number: "2",
                    text: "S’allonger correctement sur le ventre et sur le dos.",
                },
                {
                    number: "3",
                    text: "Se déplacer sur des distances de plus en plus longues.",
                },
                {
                    number: "4",
                    text: "Aller explorer la profondeur sans crainte.",
                },
                {
                    number: "5",
                    text: "Mais on termine toujours nos séances par un temps de jeu car notre principal objectif c’est de donner envie à vos enfants de revenir :)",
                },
            ],
        },
        sac: [
            {
                text: "Un maillot de bain (pas de short pour les garçons)",
            },
            {
                text: "Un bonnet de bain en silicone (pas en tissu)  ",
            },
            {
                text: "Des lunettes de piscine. Nous vous recommandons vivement les modèles Aquasphere Vista ou Vista Junior",
            },
        ],
    },
    {
        src: sectionapprentissageCouv,
        titre: "Section Apprentissage",
        age: "(À partir de 5 ans)",
        introtext: "C’est là que l’apprentissage commence pour vos enfants, à partir de 5 ans et demi",
        text: "Pour démarrer, nous nous assurons que votre enfant accepte la séparation avec les parents, qu’il soit capable de se déplacer avec une frite sur une distance de 3 mètres et qu’il soit capable de mettre la tête sous l’eau. Pour cela, avant l’inscription, nous fixons un rendez-vous.  S’il valide ces exigences, l’apprentissage peut commencer ; dans le cas contraire, nous vous orientons vers la section découverte le temps que votre enfant soit à l’aise avec ces prérequis.",
        icon: <SwimIcon />,
        iconGradient: <SwimIcon gradient />,
        link: "/natation-enfants-ca",
        slug: "natation-enfants-ca",
        profil: "enfant",
        swiper: [
            {
                images: enfant1,
            },
            {
                images: enfant2,
            },
            {
                images: enfant3,
            },
            {
                images: enfant4,
            },
            {
                images: enfant5,
            },
            {
                images: enfant6,
            },
            {
                images: enfant7,
            },
            {
                images: enfant8,
            },
        ],
        duree: {
            label: "durée",
            value: "30'",
        },
        descrption: {
            titre: "Comment ça s'organise ?",
            text: "<p>La durée des cycles correspond généralement à la période scolaire entre chaque rentrée et chaque vacances. Nous vous suggérons de visiter la page tarifs où ces périodes sont indiquées avec précision.</p><br/><p>Vous pouvez vous inscrire tout au long de l’année pour que vos enfants puissent débuter les cours au plus vite. Plus on les met vite dans le bain, et plus l’apprentissage s’effectue facilement…</p><br/><br/><p><strong>Attention :</strong> notre pédagogie est exigeante mais elle est surtout bienveillante. Chaque enfant avance à son rythme et vous pouvez estimer que vos enfants savent nager – et donc qu’ils ne risquent pas de se noyer – quand ils ont validé les objectifs du niveau 3.</p><br/><p>S’ils ont pris goût à la natation, sachez qu’ils peuvent s’inscrire à nos cours de perfectionnement…</p>",
        },
        bienfaits: {
            titre: "Les objectifs",
            baseline: "L’apprentissage est divisé en 4 niveaux",
            swiper: [
                {
                    text: "<ul><li>Mettre la tête sous l’eau sans respirer pendant 5 secondes.</li><br/><li>Maîtriser la respiration aquatique, à savoir inspirer par la bouche et expirer par le nez.</li><br/><li>Traverser la largeur sur le dos et sur le ventre.</li></ul>",
                },
                {
                    text: "<p>Traverser la longueur sur le dos et sur le ventre</p>",
                },
                {
                    text: "<p>Maîtriser le crawl et le dos</p>",
                },
                {
                    text: "<p>Maîtriser les 4 nages.</p>",
                },
            ],
        },
        enpratique: {
            items: [
                {
                    number: "1",
                    text: "Intégrer et maitriser la respiration aquatique « inspirer par la bouche et souffler par le nez »",
                },
                {
                    number: "2",
                    text: "S’allonger correctement sur le ventre et sur le dos.",
                },
                {
                    number: "3",
                    text: "Se déplacer sur des distances de plus en plus longues.",
                },
                {
                    number: "4",
                    text: "Aller explorer la profondeur sans crainte",
                },
                {
                    number: "5",
                    text: "Plus on augmente dans les niveaux et plus les objectifs sont difficiles. Mais nous serons accompagner vos enfants tout au long de leur évolution :)",
                },
            ],
        },
        sac: [
            {
                text: "Un maillot de bain (pas de short pour les garçons)",
            },
            {
                text: "Un bonnet de bain en silicone (pas en tissu)  ",
            },
            {
                text: "Des lunettes de piscine. Nous vous recommandons vivement les modèles Aquasphere Vista ou Vista Junior",
            },
        ],
    },
    {
        src: sectionperfectionnementCouv,
        titre: "Section Perfectionnement",
        age: "(À partir de 6 ans)",
        introtext: "Pour apprendre à nager sans stress ni sélection.",
        text: "Dès l’âge de 6 ans (en moyenne), les enfants peuvent intégrer la Section Perfectionnement s’ils savent déjà nager au moins une nage. Notre méthode favorise une pratique par étape et par nage : crawl, dos, puis papillon et brasse.",
        icon: <SwimIcon />,
        iconGradient: <SwimIcon gradient />,
        link: "/natation-enfants-p1",
        slug: ["natation-enfants-p1"],
        profil: "enfant",
        swiper: [
            {
                images: enfant1,
            },
            {
                images: enfant2,
            },
            {
                images: enfant3,
            },
            {
                images: enfant4,
            },
            {
                images: enfant5,
            },
            {
                images: enfant6,
            },
            {
                images: enfant7,
            },
            {
                images: enfant8,
            },
        ],
        duree: {
            label: "durée",
            value: "45'",
        },
        objectifs: {
            titre: "Les objectifs",
            baseline: "apprendre à nager bien-sûr ;)",
            text: "La section perfectionnement est entièrement dédiée à l'acquisition des 4 nages, dans un ordre très précis : d'abord le crawl, puis le crawl et le dos, puis le crawl, le dos et le papillon. Et enfin, la brasse, qui est la nage la plus technique et la plus difficile à mettre en oeuvre. A Vital'Eau, nous préférons donc aborder cette nage une fois que les 3 autres sont bien assimilées. Au fur et à mesure de sa pratique, votre enfant deviendra de plus en plus autonome dans l'eau.",
        },
        bienfaits: {
            titre: "Les bienfaits",
            swiper: [
                {
                    text: "Une pratique intense qui reste ludique, sans stress ni sélection.",
                },
                {
                    text: "La sociabilisation de votre enfant grâce au travail en groupe.",
                },
                {
                    text: "Un développement musculaire - et cérébral - complet et harmonieux.",
                },
                {
                    text: "L’acquisition progressive d’une autonomie complète en milieu aquatique.",
                },
            ],
        },
        pourqui: {
            titre: "Pour qui ?",
            baseline: "tous les enfants sont les bienvenus",
            text: "Pour les enfants et les adolescents de 6 à 15 ans.",
        },
        enpratique: {
            items: [
                {
                    number: "1",
                    text: " Les groupes sont organisés en 4 niveaux : Perfectionnement 1, 2, 3 et 4.",
                },
                {
                    number: "2",
                    text: " Les cours ont lieu du lundi au vendredi hors vacances scolaires et jours fériés.",
                },
                {
                    number: "3",
                    text: "Le port des lunettes de natation et du bonnet de bain sont obligatoires. Et oui sans ces accessoires les enfants ne peuvent pas progresser :)",
                },
            ],
        },
        sac: [
            {
                text: "Un maillot de bain (pas de short pour les garçons)",
            },
            {
                text: "Un bonnet de bain en silicone (pas en tissu)  ",
            },
            {
                text: "Des lunettes de piscine. Nous vous recommandons vivement les modèles Aquasphere Vista ou Vista Junior",
            },
        ],
    },
    {
        src: sectiondecouverteCouv,
        titre: "Section découverte",
        age: "(à partir de 3 ans avec parents)",
        introtext: "Une première approche ludique de la natation.",
        text: "Véritable transition entre les bébés nageurs et l’apprentissage plus « formel » de la natation, la section Découverte mise sur l’amusement et le bien-être pour favoriser l’épanouissement de votre enfant dans l’eau.",
        icon: <SwimIcon />,
        iconGradient: <SwimIcon gradient />,
        link: "/section-decouverte-a-partir-de-3-ans",
        slug: "section-decouverte-a-partir-de-3-ans",
        profil: "enfant",
        swiper: [
            {
                images: decouverte1,
            },
            {
                images: decouverte2,
            },
            {
                images: decouverte3,
            },
            {
                images: decouverte4,
            },
        ],
        duree: {
            label: "durée",
            value: "30'",
        },
        participants: {
            label: "participants",
            value: "20/cours",
        },
        objectifs: {
            titre: "Les objectifs",
            baseline: "comme un poisson dans l’eau",
            text: "Aider votre enfant à se familiariser avec l’eau à son rythme, grâce à des jeux et à des exercices adaptés. Nous insistons sur la dimension ludique des séances, et nous nous assurons que la progression de votre enfant se fasse en toute sécurité, dans le respect de ses capacités motrices et psychologiques.",
        },
        bienfaits: {
            titre: "Les bienfaits",
            swiper: [
                {
                    text: "Les enfants acquièrent rapidement une telle confiance, qu’ils prennent d’eux-mêmes des initiatives dans l’eau.",
                },
                {
                    text: " Ils ne craignent plus les éclaboussures, apprennent à bloquer leur respiration et à mettre la tête sous l’eau sans boire la tasse… Et même à sauter sans peur.",
                },
            ],
        },
        pourqui: {
            titre: "Pour qui ?",
            baseline: "pour tous les enfants voyons :)",
            text: "Dans la continuité des Bébés Nageurs, la section Découverte s’adresse aux jeunes enfants à partir de 3 ans, toujours en présence d’au moins un parent accompagnateur dans l’eau avec l’enfant, pour l’accompagner, le rassurer et l’encourager.",
        },
        seancebaseline: "chacun son rythme",
        seance: [
            {
                number: "1",
                text: "Un temps de travail sur le ventre.",
            },
            {
                number: "2",
                text: "Un temps de travail sur le dos.",
            },
            {
                number: "3",
                text: "L’apprentissage des immersions et des sauts.",
            },
            {
                number: "4",
                text: "Un moment de jeux et de récréation tous ensemble pour clore la séance.",
            },
        ],
        enpratique: {
            items: [
                {
                    number: "1",
                    text: "Eau propre, non agressive et chauffée à 33°.",
                },
                {
                    number: "2",
                    text: "Présence obligatoire d’un adulte accompagnants dans l’eau (papa ou maman ou ou membre de la famille).",
                },
                {
                    number: "3",
                    text: "On peut commencer à envisager le port du bonnet et des lunettes de piscine pour une meilleure appréhension des exercices proposés.",
                },
            ],
        },
        sac: [
            {
                text: "Un maillot de bain (pas de short pour les garçons)",
            },
            {
                text: "Un bonnet de bain en silicone (pas en tissu)  ",
            },
            {
                text: "Des lunettes de piscine. Nous vous recommandons vivement les modèles Aquasphere Vista ou Vista Junior",
            },
        ],
    },
    {
        src: stageNatationCouv,
        titre: "Stage 100% natation",
        age: "(À partir de 4 ans)",
        introtext: "Uniquement pendant les vacances scolaires",
        text: "Accessible dès l’âge de 4 ans, les stages 100% Natation se déroulent exclusivement pendant les vacances scolaires et sont organisés en sessions courtes et intensives pour maximiser les progrès des enfants. Il s’adressent aux enfants qui ne savent pas nager.",
        icon: <SwimIcon />,
        iconGradient: <SwimIcon gradient />,
        link: "/stages-de-natation",
        slug: "stages-de-natation",
        profil: "enfant",
        descrption: {
            titre: "Comment ça s'organise ?",
            baseline: "Les enfants à partir de 4 ans ne sachant pas nager",
            text: '<p>Merci de venir avec une fiche d’inscription remplie. Elle est disponible via ce lien : <a href="https://vitaleau.fr/inscription">ici</a>.</p><br/><p>Si vous ne l’avez pas, vous pouvez inscrire sur papier libre : Nom, prénom, date de naissance de votre enfant,<br>votre adresse mail et votre numéro de téléphone.</p><br/><p>Le paiement se fera uniquement par chèque ou en espèces.</p><br/><p>Attention : les séances manquées ne pourront pas être rattrapées.</p><br/><br/><p>Avant la fin de chaque stage, vous recevrez :</p><br/><p>• Une fiche d’évaluation par mail, pour faire le point sur les progrès de votre enfant.</p><p>• Un SMS concernant les réinscriptions, si votre enfant souhaite poursuivre.</p><br/><p>Les enfants sont considérés comme nageurs une fois toutes les exigences du niveau 3 validées, à savoir : nager 6 longueurs en crawl et 6 longueurs en dos.</p>',
            horaire:
                "<p>Du lundi au jeudi, aux alentours de 18h.</p><br/><p>Attention : l’horaire définitif vous sera envoyé par SMS, au plus tard 10 jours avant le début des cours pour les cycles d’apprentissage, et 3 jours avant pour les stages.</p>",
        },
        swiper: [
            {
                images: enfant1,
            },
            {
                images: enfant2,
            },
            {
                images: enfant3,
            },
            {
                images: enfant4,
            },
            {
                images: enfant5,
            },
            {
                images: enfant6,
            },
            {
                images: enfant7,
            },
            {
                images: enfant8,
            },
        ],
        duree: {
            label: "durée",
            value: "40'",
        },
        bienfaits: {
            titre: "Les objectifs",
            swiper: [
                {
                    text: "Apprendre à votre enfant à mettre le tête sous l'eau",
                },
                {
                    text: "À inspirer par la bouche et expirer sous l’eau par le nez",
                },
                {
                    text: "A traverser la largeur du bassin sur le ventre et sur le dos. (Si c’est possible la longueur aussi :))",
                },
            ],
        },
        pourqui: {
            titre: "Pour qui ?",
            baseline: "tous les enfants sont les bienvenus :)",
            text: "Les enfants à partir de 4 ans ne sachant pas nager",
        },
        enpratique: {
            titre: "Les objectifs principaux du stage",
            baseline: "On vous dit tout",
            items: [
                {
                    number: "1",
                    text: "Maîtrise de la respiration aquatique",
                },
                {
                    number: "2",
                    text: "Traverser une largeur sur le ventre",
                },
                {
                    number: "3",
                    text: "Traverser une largeur sur le dos",
                },
            ],
        },
        sac: [
            {
                text: "Un maillot de bain (pas de short pour les garçons)",
            },
            {
                text: "Un bonnet de bain en silicone (pas en tissu)  ",
            },
            {
                text: "Des lunettes de piscine. Nous vous recommandons vivement les modèles Aquasphere Vista ou Vista Junior",
            },
        ],
    },
    {
        src: aquagymtonicCouv,
        titre: "AquaGym Tonic",
        introtext: "Le parfait compromis entre sport et détente",
        text: "L'aquagym tonique est notre version dynamique d'exercice aquatique qui combine les bienfaits de l'aquagym traditionnelle avec une intensité accrue. Conçue pour renforcer le corps, améliorer la condition physique et stimuler le système cardiovasculaire. Les séances d'aquagym tonique impliquent des mouvements énergiques et des exercices ciblés, mettant à contribution la résistance de l'eau pour accroître l'effort musculaire. Les participants effectuent des mouvements variés tels que des sauts, des foulées, des mouvements de bras et des exercices de renforcement musculaire tout en faisant face à la résistance naturelle de l'eau. Nous utilisons aussi beaucoup de matériels tels que les frites, les altères, les snakes et bien d’autres accessoires pour vous proposer des séances très variées. L'avantage clé de l'aquagym tonique réside dans la faible pression exercée sur les articulations, ce qui en fait une option idéale pour les personnes cherchant à minimiser l'impact sur les genoux, les hanches et autres zones sensibles. En plus des bienfaits musculaires et cardiovasculaires, l'aquagym tonique favorise également la coordination, l'équilibre et la flexibilité. En outre, la résistance de l'eau offre une séance d'entraînement complète, engageant de nombreux groupes musculaires simultanément.",
        icon: <AquagymIcon />,
        iconGradient: <AquagymIcon gradient />,
        link: "/aquagym-tonic",
        slug: "aquagym-tonic",
        profil: "adulte",
        youtubelink: "https://www.youtube.com/shorts/dHmLMTwU9l4",
        swiper: [
            {
                images: aquatonic1,
            },
            {
                images: aquatonic2,
            },
            {
                images: aquatonic3,
            },
            {
                images: aquatonic4,
            },
        ],
        duree: {
            label: "durée",
            value: "45'",
        },
        intensite: {
            label: "Intensité",
            value: "Intense à très intense",
        },
        calories: {
            label: "Calories",
            value: "≈ 600",
        },
        bienfaits: {
            titre: "Les bienfaits",
            baseline: "prêt(e)s à vous faire du bien ?",
            swiper: [
                {
                    text: "Amélioration de la mobilité articulaire : L'eau réduit l'impact sur les articulations (jusqu'à 90 % de décharge du poids corporel) favorisant une meilleure amplitude des mouvements.",
                },
                {
                    text: "Renforcement musculaire sans risque : Les exercices en immersion musclent tous les groupes musculaires : jambes, dos, bras.",
                },
                {
                    text: "Stimulation cardiovasculaire : Elle augmente le rythme cardiaque améliorant la circulation sanguine et la capacité cardiorespiratoire. ",
                },
                {
                    text: "Réduction du stress et amélioration de l'humeur : Les mouvements rythmés et l'environnement aquatique libèrent des endorphines, diminuant l'anxiété et la dépression, tout en favorisant un sentiment de bien-être et de relaxation.",
                },
            ],
        },
        pourqui: {
            titre: "Pour qui ?",
            baseline: "Cette activité s’adresse à tous",
            text: "L’activité est ouverte à tous, débutants ou confirmés. Il est nécessaire de savoir nager pour participer et il est possible d’intégrer les cours à tout moment de l’année.",
        },
        seancebaseline: "un début, un pendant et une fin",
        seance: [
            {
                number: "1",
                text: "On démarre par un échauffement spécifique.",
            },
            {
                number: "2",
                text: "On enchaîne avec une série d’exercices de travail d’intervalle training en ciblant les jambes et les fessiers",
            },
            {
                number: "3",
                text: "On poursuit par travailler la résistance en ciblant le haut du corps ",
            },
            {
                number: "4",
                text: "On continue le travail dynamique en ciblant les abdominaux.",
            },
        ],
    },
    {
        src: aquabikedynamic,
        titre: "Aquabike Dynamic",
        introtext: "Installé sur des vélos révolutionnaires, vous travaillerez l'ensemble de vos groupes musculaires",
        text: "Nos vélos aussi avant-gardistes sur le plan du design que confortables, offrent une approche de renforcement musculaire complète, incluant même le haut du corps. Ils présentent ainsi l'avantage significatif de proposer une diversité d'exercices bien plus étendue que celle offerte par un aquabike conventionnel.",
        icon: <AquabikeIcon />,
        iconGradient: <AquabikeIcon gradient />,
        link: "/aquabike-dynamic",
        slug: "aquabike-dynamic",
        profil: "adulte",
        youtubelink: "https://www.youtube.com/shorts/xHqGbBAJBq4",
        swiper: [
            {
                images: aquadynamic1,
            },
            {
                images: aquadynamic2,
            },
            {
                images: aquadynamic3,
            },
        ],
        duree: {
            label: "durée",
            value: "30'",
        },
        intensite: {
            label: "Intensité",
            value: "Très forte",
        },
        calories: {
            label: "Calories",
            value: "≈ 600",
        },
        bienfaits: {
            titre: "Les bienfaits",
            baseline: "prêt(e)s à vous faire du bien ?",
            swiper: [
                {
                    text: "Renforcement Musculaire Global : Tous les exercices qui sont proposés sollicitent de nombreux groupes musculaires, contribuant au renforcement général du corps, y compris les jambes, les fessiers et les muscles du tronc.",
                },
                {
                    text: "Impact Articulaire Réduit : L'eau crée une résistance naturelle, mais elle soutient également le poids du corps, réduisant ainsi l'impact sur les articulations",
                },
                {
                    text: "Élimination des Toxines : L'immersion dans l'eau favorise la circulation lymphatique, ce qui contribue à l'élimination des toxines du corps. Cela peut aider à réduire la rétention d'eau et à stimuler le métabolisme.",
                },
                {
                    text: "Gestion du Poids : L’Aqua bike dynamic, en tant qu'activité à la fois cardiovasculaire et de renforcement musculaire, contribue à la perte de poids ou au maintien d'un poids santé, tout en offrant une alternative agréable aux exercices terrestres.",
                },
                {
                    text: "Amélioration de la Souplesse et de la Mobilité : Les mouvements fluides dans l'eau favorisent l'étirement des muscles, améliorant ainsi la souplesse et la mobilité articulaire.",
                },
                {
                    text: "Réduction du Stress et de la Tension : L’entrainement si il est régulier apaise l'esprit et permets de réduire le stress et la tension.",
                },
            ],
        },
        pourqui: {
            titre: "Pour qui ?",
            baseline: "Pour tout les plus aguerrie :)",
            text: "Cette version intense s’adresse aux plus sportifs d’entre vous, mais ne vous inquiétez pas, nous proposons aussi une version plus douce appelle aquabike adaptée à tous.",
        },
        seancebaseline: "un début, un pendant et une fin",
        seance: [
            {
                number: "1",
                text: "On démarre par un échauffement spécifique.",
            },
            {
                number: "2",
                text: "On enchaîne avec une série d’exercices de en travaillant l'explosivité",
            },
            {
                number: "3",
                text: "On poursuit par travailler l'endurance",
            },
            {
                number: "4",
                text: "On termine avec un retour au calme et à la récupération.",
            },
        ],
    },
    {
        src: bodyBike,
        titre: "Body Bike",
        introtext: "Défi cuisse abdo fessiers !",
        text: "Les séances se composent généralement de 30 minutes de travail avec les bongos et 15 minutes de travail d’abdo en suspension.</p> Installé(e)s sur des vélos révolutionnaires immergés dans l’eau, vous travaillerez tous les muscles. Les Bongos, vélos aussi designs que confortables, permettent un travail de gainage complet, y compris du haut du corps. Ils présentent donc l’avantage d’offrir une gamme d’exercices bien plus importante que sur un aquabike classique.",
        icon: <AquabikeIcon />,
        iconGradient: <AquabikeIcon gradient />,
        link: "/body-bike",
        slug: "body-bike",
        profil: "adulte",
        youtubelink: "https://www.youtube.com/shorts/3gQRxwK5HEw",
        swiper: [
            {
                images: body3,
            },
            {
                images: body1,
            },
            {
                images: body4,
            },
            {
                images: body5,
            },
        ],
        duree: {
            label: "durée",
            value: "45'",
        },
        intensite: {
            label: "Intensité",
            value: "forte et ciblée",
        },
        calories: {
            label: "Calories",
            value: "700",
        },
        bienfaits: {
            titre: "Les bienfaits",
            baseline: "prêt(e)s à vous faire du bien ?",
            swiper: [
                {
                    text: "Renforcement Musculaire Global : Tous les exercices qui sont proposés sollicitent de nombreux groupes musculaires, contribuant au renforcement général du corps, y compris les jambes, les fessiers et les muscles du tronc.",
                },
                {
                    text: "Impact Articulaire Réduit : L'eau crée une résistance naturelle, mais elle soutient également le poids du corps, réduisant ainsi l'impact sur les articulations",
                },
                {
                    text: "Élimination des Toxines : L'immersion dans l'eau favorise la circulation lymphatique, ce qui contribue à l'élimination des toxines du corps. Cela peut aider à réduire la rétention d'eau et à stimuler le métabolisme.",
                },
                {
                    text: "Gestion du Poids : Le Body Bike, en tant qu'activité à la fois cardiovasculaire et de renforcement musculaire, contribue à la perte de poids ou au maintien d'un poids santé, tout en offrant une alternative agréable aux exercices terrestres.",
                },
                {
                    text: "Amélioration de la Souplesse et de la Mobilité : Les mouvements fluides dans l'eau favorisent l'étirement des muscles, améliorant ainsi la souplesse et la mobilité articulaire.",
                },
                {
                    text: "Réduction du Stress et de la Tension : L’entrainement si il est régulier apaise l'esprit et permets de réduire le stress et la tension.",
                },
            ],
        },
        pourqui: {
            titre: "Pour qui ?",
            baseline: "toi peut-être :)",
            text: "Pour tout le monde, débutants et confirmés, à condition de savoir nager.",
        },
        seancebaseline: "un début, un pendant et une fin",
        seance: [
            {
                number: "1",
                text: "Sur son Aquabike, on démarre par un échauffement général du corps.",
            },
            {
                number: "2",
                text: "On enchaîne avec une série d’exercices sur le vélo, pendant 30 minutes.",
            },
            {
                number: "3",
                text: "On continue avec une série d’exercices abdominaux, pendant 15 minutes.",
            },
            {
                number: "4",
                text: "Les cours se font en musique, pour plus de fun, de rythme et de motivation.",
            },
        ],
    },
    {
        src: aquatrainingCouv,
        titre: "Aqua Training",
        introtext: "La version du « crossfit » aquatique",
        text: "Plongez dans l'univers imaginaire d'un bassin transformé en authentique salle de cross-training, où des équipements tels que vélos, trampolines et surtout sacs de frappe sont méticuleusement agencés. Oui, vous avez bien lu : nous l'avons réalisé, et vous vous apprêtez à vivre une expérience où vous pourrez vous défouler comme jamais auparavant. Chaque session dans ce bassin réaménagé devient une occasion unique d'allier la puissance de l'entraînement aquatique à l'adrénaline d'une séance de cross-fit. Les maîtres-nageurs vous coacheront pour créer une atmosphère dynamique et stimulante. Préparez-vous à libérer vos énergies refoulées et à repousser vos limites physiques. Rejoignez-nous pour une immersion totale dans ce concept innovant !",
        icon: <AquagymIcon />,
        iconGradient: <AquagymIcon gradient />,
        link: "/aqua-training",
        slug: "aqua-training",
        profil: "adulte",
        youtubelink: "https://www.youtube.com/shorts/xuPe0Bh5jX8",
        swiper: [
            {
                images: aquatraining4,
            },
            {
                images: aquatraining1,
            },
            {
                images: aquatraining2,
            },
            {
                images: aquatraining3,
            },
            {
                images: aquatraining5,
            },
            {
                images: aquatraining6,
            },
        ],
        duree: {
            label: "durée",
            value: "45 min",
        },
        intensite: {
            label: "Intensité",
            value: "Intense à très intense",
        },
        calories: {
            label: "Calories",
            value: "≈ 800",
        },
        bienfaits: {
            titre: "Les bienfaits",
            baseline: "prêt(e)s à vous faire du bien ?",
            swiper: [
                {
                    text: "Renforcement Musculaire Global : Tous les exercices qui sont proposés sollicitent de nombreux groupes musculaires, contribuant au renforcement général du corps, y compris les jambes, les fessiers et les muscles du tronc",
                },
                {
                    text: "Impact Articulaire Réduit : L'eau crée une résistance naturelle, mais elle soutient également le poids du corps, réduisant ainsi l'impact sur les articulations",
                },
                {
                    text: "Élimination des Toxines : L'immersion dans l'eau favorise la circulation lymphatique, ce qui contribue à l'élimination des toxines du corps. Cela peut aider à réduire la rétention d'eau et à stimuler le métabolisme",
                },
                {
                    text: "Gestion du Poids : L’Aquatraining, en tant qu'activité à la fois cardiovasculaire et de renforcement musculaire, contribue à la perte de poids ou au maintien d'un poids santé, tout en offrant une alternative agréable aux exercices terrestres.",
                },
                {
                    text: "Amélioration de la Souplesse et de la Mobilité : Les mouvements fluides dans l'eau favorisent l'étirement des muscles, améliorant ainsi la souplesse et la mobilité articulaire.",
                },
                {
                    text: "Réduction du Stress et de la Tension : L’entrainement si il est régulier apaise l'esprit et permets de réduire le stress et la tension. ",
                },
            ],
        },
        pourqui: {
            titre: "Pour qui ?",
            baseline: "Ceux qui veulent dépasser leur limite",
            text: "Entre les vélos, les minis trampolines individuels, les accessoires d’aquagym dernier cri et les sessions avec des sacs de frappe unique au monde ou vous pourrez vous défoulez en chainant les combinaisons de coup de poing, de pied et de genoux  nos circuits d’Aqua training vont vous rendre addicts à l’effort. Cette activité s’adresse à ceux qui souhaitent un entraînement intensif et ludique pour faire monter le cardio et dépenser un maximum de calories, sans jamais s’ennuyer",
        },
        seancebaseline: "un début, un pendant et une fin",
        seance: [
            {
                number: "1",
                text: "On démarre par la présentation de la séance et échauffementun général du corps.",
            },
            {
                number: "2",
                text: "On enchaîne avec un circuit en travail d’interval training",
            },
            {
                number: "3",
                text: "On poursuit par un travail d'endurance",
            },
            {
                number: "4",
                text: "On termine avec un retour au calme et à la récupération.",
            },
        ],
    },
    {
        src: aquafitness,
        titre: "Aquafitness",
        introtext: "Respecter le rythme et les capacités de chacun",
        text: "Aquafitness permet de (re)mettre votre corps en mouvement sans aucune charge sur les articulations et dans le respect de leurs possibilités musculaires, articulaires et cardiaques. La circulation sanguine et le drainage lymphatique va s’améliorer. Le dos et la ceinture lombaire seront plus solides et résistants. Petit à petit, vous allez diminuer le risque de chutes au quotidien et gagner en coordination, en équilibre et en mobilité. Votre système cardio-vasculaire deviendra plus efficace et vous gagnerez en amplitude respiratoire. Contrairement à l’aquagym, l’Aquafitness utilise divers équipements, tels que des frites pour travailler les muscles abdominaux ou la coordination bras-jambes, des haltères et des serpents pour solliciter l’ensemble du corps, ainsi que des accessoires comme des brochettes, des ballons, et même des vélos, dans un format de circuit training. L’objectif est de proposer des séances variées chaque semaine, pour éviter la monotonie.",
        icon: <AquagymIcon />,
        iconGradient: <AquagymIcon gradient />,
        slug: "aquafitness",
        profil: "sénior",
        youtubelink: "https://www.youtube.com/shorts/rA_RlGE_lNU",
        descrption: {
            text: "",
        },
        swiper: [
            {
                images: aquafitness1,
            },
            {
                images: aquafitness2,
            },
            {
                images: aquafitness3,
            },
            {
                images: aquafitness4,
            },
        ],
        duree: {
            label: "durée",
            value: "45'",
        },
        intensite: {
            label: "Intensité",
            value: "modérée",
        },
        calories: {
            label: "Calories",
            value: "entre 300 et 500",
        },
        bienfaits: {
            titre: "Les bienfaits",
            baseline: "grâce à la pratique de l'aquafitness",
            swiper: [
                {
                    text: "Amélioration de la mobilité articulaire : L'eau réduit l'impact sur les articulations (jusqu'à 90 % de décharge du poids corporel), soulageant les douleurs liées à l'arthrose ou à l'arthrite, et favorisant une meilleure amplitude des mouvements.",
                },
                {
                    text: "Renforcement musculaire sans risque : Les exercices en immersion musclent tous les groupes musculaires (jambes, dos, bras), aidant à prévenir la sarcopénie (perte de masse musculaire due à l'âge), tout en minimisant le risque de chutes",
                },
                {
                    text: "Stimulation cardiovasculaire : Elle augmente le rythme cardiaque de manière modérée, améliorant la circulation sanguine et la capacité cardiorespiratoire, ce qui réduit les risques d'hypertension et d'infarctus chez les personnes âgées.",
                },
                {
                    text: "Réduction du stress et amélioration de l'humeur : Les mouvements rythmés et l'environnement aquatique libèrent des endorphines, diminuant l'anxiété et la dépression, tout en favorisant un sentiment de bien-être et de relaxation.",
                },
                {
                    text: " Aspect social et cognitive : Pratiquée en groupe, elle combat l'isolement social fréquent chez les seniors, stimule la mémoire et la coordination, et renforce les liens intergénérationnels pour un meilleur équilibre mental.",
                },
            ],
        },
        pourqui: {
            titre: "Pour qui ?",
            baseline: "toi peut-être :)",
            text: "Pour reprendre le sport ou entretenir votre forme en douceur, en privilégiant le bien-être à l’effort. Les femmes enceintes sont les bienvenues et il n’est pas nécessaire de savoir nager pour participer.",
        },
        seancebaseline: "un début, un pendant et une fin",
        seance: [
            {
                number: "1",
                text: "On démarre par un échauffement général du corps.",
            },
            {
                number: "2",
                text: "On enchaîne avec une série d’exercices toujours renouvelés, avec OU sans matériel.",
            },
            {
                number: "3",
                text: "On termine avec un retour au calme et à la récupération.",
            },
            {
                number: "4",
                text: "Les cours se font en musique, avec des playlists adaptées.",
            },
        ],
    },
    {
        src: aquabike,
        titre: "Aquabike",
        introtext: "Installé sur des vélos révolutionnaires, vous travaillerez l'ensemble de vos groupes musculaires.",
        text: "Nos vélos aussi avant-gardistes sur le plan du design que confortables, offrent une approche de renforcement musculaire complète, incluant même le haut du corps. Ils présentent ainsi l'avantage significatif de proposer une diversité d'exercices bien plus étendue que celle offerte par un aquabike conventionnel.",
        icon: <AquabikeIcon />,
        iconGradient: <AquabikeIcon gradient />,
        link: "/aquabike",
        slug: "aquabike",
        profil: "sénior",
        youtubelink: "https://www.youtube.com/shorts/xHqGbBAJBq4",
        swiper: [
            {
                images: aquabike1,
            },
            {
                images: aquabike2,
            },
            {
                images: aquabike3,
            },
            {
                images: aquabike5,
            },
            {
                images: aquabike6,
            },
        ],
        duree: {
            label: "durée",
            value: "30'",
        },
        intensite: {
            label: "Intensité",
            value: "Modérée à intense",
        },
        calories: {
            label: "Calories",
            value: "450",
        },
        bienfaits: {
            titre: "Les bienfaits",
            baseline: "prêt(e)s à vous faire du bien ?",
            swiper: [
                {
                    text: "Amélioration de la mobilité articulaire : L'eau réduit l'impact sur les articulations (jusqu'à 90 % de décharge du poids corporel), soulageant les douleurs liées à l'arthrose ou à l'arthrite, et favorisant une meilleure amplitude des mouvements.",
                },
                {
                    text: "Renforcement musculaire sans risque : Les exercices en immersion musclent en douceur les groupes musculaires (jambes, dos, bras), aidant à prévenir la sarcopénie (perte de masse musculaire due à l'âge), tout en minimisant le risque de chutes.",
                },
                {
                    text: "Stimulation cardiovasculaire : La pratique de l’aquabike augmente le rythme cardiaque de manière modérée, améliorant la circulation sanguine et la capacité cardiorespiratoire, ce qui réduit les risques d'hypertension et d'infarctus chez les personnes âgées.",
                },
                {
                    text: "Réduction du stress et amélioration de l'humeur : Les mouvements rythmés et l'environnement aquatique libèrent des endorphines, diminuant l'anxiété et la dépression, tout en favorisant un sentiment de bien-être et de relaxation.",
                },
                {
                    text: "Aspect social et cognitive : Pratiquée en groupe, elle combat l'isolement social fréquent chez les seniors, stimule la mémoire et la coordination, et renforce les liens intergénérationnels pour un meilleur équilibre mental.",
                },
            ],
        },
        pourqui: {
            titre: "Pour qui ?",
            baseline: "toi peut-être :)",
            text: "Pour tout le monde, débutants et confirmés.",
        },
        seancebaseline: "un début, un pendant et une fin",
        seance: [
            {
                number: "1",
                text: "On démarre par un échauffement spécifique.",
            },
            {
                number: "2",
                text: "On enchaîne avec une série d’exercices de en travaillant l'explosivité",
            },
            {
                number: "3",
                text: "On poursuit par travailler l'endurance",
            },
            {
                number: "4",
                text: "On termine avec un retour au calme et à la récupération.",
            },
        ],
    },
    {
        src: aquagymdouceCouv,
        titre: "AquaGym",
        introtext: "Place à la détente et à la relaxation",
        text: " L’Aquagym s’adresse aux pratiquants les plus âgés et à toutes les personnes qui souhaitent maintenir leur forme physique - et morale - via une activité douce et de bien-être. Vous aurez les mêmes bienfaits que l’AquaGym, avec des exercices adaptés à votre état de forme.",
        icon: <AquagymIcon />,
        iconGradient: <AquagymIcon gradient />,
        link: "/aquagym",
        slug: "aquagym",
        profil: "sénior",
        youtubelink: "https://www.youtube.com/shorts/hus_nFzFhIE",
        swiper: [
            {
                images: aquagym1,
            },
            {
                images: aquagym2,
            },
            {
                images: aquagym3,
            },
            {
                images: aquagym4,
            },
            {
                images: aquagym5,
            },
        ],
        bienfaits: {
            titre: "Les bienfaits",
            baseline: " Voici cinq bienfaits majeurs, soutenus par des études en gérontologie et kinésithérapie",
            swiper: [
                {
                    text: "1. Amélioration de la mobilité articulaire : L'eau réduit l'impact sur les articulations (jusqu'à 90 % de décharge du poids corporel), soulageant les douleurs liées à l'arthrose ou à l'arthrite, et favorisant une meilleure amplitude des mouvements.",
                },
                {
                    text: "2. Renforcement musculaire sans risque : Les exercices en immersion musclent en douceur les groupes musculaires (jambes, dos, bras), aidant à prévenir la sarcopénie (perte de masse musculaire due à l'âge), tout en minimisant le risque de chutes.",
                },
                {
                    text: "3. Stimulation cardiovasculaire : Elle augmente le rythme cardiaque de manière modérée, améliorant la circulation sanguine et la capacité cardiorespiratoire, ce qui réduit les risques d'hypertension et d'infarctus chez les personnes âgées.",
                },
                {
                    text: "4. Réduction du stress et amélioration de l'humeur : Les mouvements rythmés et l'environnement aquatique libèrent des endorphines, diminuant l'anxiété et la dépression, tout en favorisant un sentiment de bien-être et de relaxation.",
                },
                {
                    text: "5. Aspect social et cognitive : Pratiquée en groupe, elle combat l'isolement social fréquent chez les seniors, stimule la mémoire et la coordination, et renforce les liens intergénérationnels pour un meilleur équilibre mental.",
                },
            ],
        },

        seance: [
            {
                number: "1",
                text: "On démarre par un échauffement.",
            },
            {
                number: "2",
                text: "On enchaîne avec un travail spécifique du haut du corps",
            },
            {
                number: "3",
                text: "On poursuit avec un travail spécifique du bas du corps",
            },
            {
                number: "4",
                text: "Pas d’accélération cardiaque et d’impact pendant les séances",
            },
        ],
    },
];

export default activites;
